import React from 'react';
import PropTypes from 'prop-types';
import { QueryRenderer, graphql } from 'react-relay';
import RelayService from '../service/RelayService';
import Loading from '../ui/Loading';
import Suggest from './Suggest';
import WebIntlProvider from '../ui/i18n/WebIntlProvider';

export default class SuggestLoader extends React.Component {

  static propTypes = {
    rfType: PropTypes.string, //TD identifier to determine the location of the Suggest component
    disableMarketplaceBanner: PropTypes.bool,
  };

  render() {
    return (
      <QueryRenderer
        environment={RelayService.environment}
        query={graphql`
        query SuggestLoaderQuery {
            suggestSearch {
                ...Suggest_suggestSearch
            }
        }
      `}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            let tdComponentName = 'suggest-center';
            if (this.props.rfType == '1104') {
              tdComponentName = 'suggest-center-not-for-sale';
            }
            return (
              <WebIntlProvider>
                <div>
                  <Suggest tdId={`td-parts-td-${tdComponentName}`} suggestSearch={props.suggestSearch} rfType={this.props.rfType} disableMarketplaceBanner={this.props.disableMarketplaceBanner} />
                </div>
              </WebIntlProvider>
            );
          }
          return (
            <div className="suggest-container">
              <Loading />
            </div>
          );
        }}
      />
    )
  }

}
